/* eslint-disable no-console */
class WallpaperCalculator extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.width = 0
    this.height = 0

    // Product values are in CM
    this.productWidth = this.dataset.productWidth
    this.productHeight = this.dataset.productHeight
    this.patternOffset = this.dataset.patternOffset
  }

  setupListeners () {
    super.setupListeners()
    this.els.height.elements.forEach((input) => {
      this.listeners.add(input, `keyup`, this.storeHeight.bind(this))
    })

    this.els.width.elements.forEach((input) => {
      this.listeners.add(input, `keyup`, this.storeWidth.bind(this))
    })

    this.formatProductData()
  }

  formatProductData () {
    // convert product data into meters
    // product height is already set in meters.

    this.productWidth = this.productWidth / 100
    this.patternOffset = this.dataset.patternOffset / 100
  }

  storeWidth (event) {
    // update width value on input change
    this.width = event.target.value

    this.calculateArea()
  }

  storeHeight (event) {
    // update height value on input change
    this.height = event.target.value

    this.calculateArea()
  }

  calculateArea () {
    // How much height one roll covers
    const rollHeightCoverage = Math.floor(this.productHeight / this.height)

    // How many rolls are needed by width
    const rollsNeededByWidth = Math.ceil(this.width / this.productWidth)

    const rollsNeeded = Math.ceil(rollsNeededByWidth / rollHeightCoverage)

    let calculatedOffset = 0

    // Add offset to account for pattern matching
    if (this.patternOffset > 0 && rollsNeeded !== 0) {
      const offsetRolls = rollsNeeded - 1
      calculatedOffset = offsetRolls * this.patternOffset
    }

    // Total with Offstet

    const combinedTotal = Math.ceil(rollsNeeded + calculatedOffset)

    this.updateResults(combinedTotal)
  }

  updateResults (totalRolls) {
    const mainProductForm = this.externalEls.form.element
    mainProductForm.querySelector('.qty-Adjuster_Control-minus').disabled =
      false
    mainProductForm.querySelector('.qty-Adjuster_Control-plus').disabled =
      false
    this.els.number.element.innerHTML = totalRolls

    const input = mainProductForm.querySelector('.qty-Adjuster_Input')

    input.value = totalRolls
    input.dispatchEvent(new Event('input', { bubbles: true }))
  }
}

if (!customElements.get('wallpaper-calculator')) {
  customElements.define('wallpaper-calculator', WallpaperCalculator)
}
